/**
 * @file The main entry point for the app.
 */

/**
 * We always load polyfills for IE11 before any other JS.
 *
 * The following import polyfills these features (if not supported by the current browser):
 * - Promise
 * - fetch
 * - Object.assign
 * - Symbols
 * - Array.from
 */
import "es6-promise/auto";
import "react-app-polyfill/ie11";

/**
 * Load additional polyfills only if they are not supported.
 */
import loadPolyfills from "utils/loadPolyfills/loadPolyfills";

loadPolyfills()
  .then(function() {
    return import("app");
  })
  .catch(function(error) {
    console.error(error);
  });
